import { defineStore } from 'pinia';

export const useToastStore = defineStore('toast', {
  state: () => ({
    toasts: []
  }),
  actions: {
    add(message, type = 'info', duration = 4000) {
      const id = Date.now() + Math.random().toString(36).substring(2, 9);
      this.toasts.push({ id, message, type });
      
      if (duration > 0) {
        setTimeout(() => {
          this.remove(id);
        }, duration);
      }
    },
    success(message, duration = 4000) {
      this.add(message, 'success', duration);
    },
    error(message, duration = 6000) {
      this.add(message, 'error', duration);
    },
    warning(message, duration = 4000) {
      this.add(message, 'warning', duration);
    },
    info(message, duration = 4000) {
      this.add(message, 'info', duration);
    },
    remove(id) {
      const index = this.toasts.findIndex(t => t.id === id);
      if (index !== -1) {
        this.toasts.splice(index, 1);
      }
    }
  }
});
